import { IAccount, IReclassesAccounts } from '@modeso/types__aumico-lib-annualreport-be';
import { BorderColor } from '../../enums/adjustments-and-reclasses/BorderColor.enum';
import { CellDisplayType } from '../../types/adjustments-and-reclasses/CellDisplayType.type';

export interface IMappingDisplayItemBasic extends IAdjustmentAndReclassesAddition, Partial<RowDisplay> {
    bold: boolean;
    // this is bold in case of SUBTOTAL or GroupTotal or last FLI in group or FLI or Sub fli before subtotal
    borderDown: BorderColor;
    closing: number;
    opening: number;
    paddingTop: boolean;
    title: string;
    accountNumber?: string;
    isSubFLI?: boolean;
    level: number;
    id: string;
    childrenIds?: string[];
    isCollapsed?: boolean;
    account?: IAccount | IReclassesAccounts;
    getLatest(): void;
    isHidden: boolean;
}

interface IAdjustmentAndReclassesAddition {
    openingReClass: number | undefined;
    openingAdjustment: number | undefined;
    closingReClass: number | undefined;
    closingAdjustment: number | undefined;
}

interface RowDisplay {
    hasChild?: boolean;
    isFLI?: boolean;
    isSubFLI?: boolean;
    isGroup?: boolean;
    isSubtotal?: boolean;
    isAccount?: boolean;
    isReclasses?: boolean;
    cells: CellDisplayType[];
    class: string;
    isRowActive: boolean;
}
